import React, { Component } from 'react'
import { connect } from 'react-redux'
import s from './FutureEarningsChart.css'
import i18n from '../../../i18n.js'
import ReactEcharts from 'echarts-for-react'
import { getEarningsFutureChart } from '../charts.js'
import moment from 'moment'

class FutureEarningsChart extends Component {




  render() {
    const { filteredEarningsAggsFuture, earningsAggsFuture } = this.props;
    let minDate, formattedDate;


    if (Array.isArray(earningsAggsFuture) && earningsAggsFuture.length > 0) {
      minDate = earningsAggsFuture[0].dt;
      formattedDate = moment(minDate, "YYYY/MM/DD").format("MM/DD/YYYY");
    } else {

      minDate = moment().format("YYYY/MM/DD");
      formattedDate = minDate;
    }
    if (filteredEarningsAggsFuture) {


      return (
        <div className='earnings-details'>
          {filteredEarningsAggsFuture.length > 0 && (
            <div className={s.chartHeader}>
              <div className='row' style={{ marginBottom: '5px' }}></div>
              <div className='heading' style={{ color: '#050139', fontSize: '16px', fontWeight: '500', marginTop: '30px' }}>
                {i18n.t('forward-earnings')}{' '} {i18n.t('operating-earnings')}{' '}  As of {formattedDate}
              </div>
              <div className={s.chartContainer}>
                <ReactEcharts option={getEarningsFutureChart(filteredEarningsAggsFuture, 'ebit')} theme='default' style={{ height: 400 }} />
              </div>
              <div className='heading' style={{ color: '#050139', fontSize: '16px', fontWeight: '500', marginTop: '30px' }}>
                {i18n.t('forward-earnings')}{' '} {i18n.t('sales')}{' '}
              </div>
              <div className={s.chartContainer}>
                <ReactEcharts option={getEarningsFutureChart(filteredEarningsAggsFuture, 'sales')} theme='default' style={{ height: 400 }} />
              </div>

              {/* <div className='heading' style={{ color: '#050139', fontSize: '16px', fontWeight: '500', marginTop: '60px' }}>
                {i18n.t('forward-earnings')}{' '} {i18n.t('cashflow')}{' '}
              </div>
              <div className={s.chartContainer}>
                <ReactEcharts option={getEarningsFutureChart(filteredEarningsAggsFuture, 'cashflow')} theme='default' style={{ height: 400 }} />
              </div> */}
            </div>
          )}

        </div>
      )
    } else return null
  }
}

function mapStateToProps(state) {
  return {
    earningsConstituents: state.data.earningsConstituents,
    earningsAggsFuture: state.data.earningsAggsFuture,
    earningsAggsAll: state.data.earningsAggsAll,
    data: state.data,
    earningsType: state.data.earningsType
  }
}
export default connect(mapStateToProps, {})(FutureEarningsChart)



// WEBPACK FOOTER //
// ./src/components/App/FutureDetailsTable/FutureEarningsChart.js